module.exports = __webpack_public_path__ + "img/header5.b4185700.png";